import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import ShopifySettingsForm from '@/components/v2/ShopifySettingsForm.vue';
import ShopifySettingCreate from '@/plugins/graphql/mutations/v2/shopify-setting-create.gql';
import ShopifySettingUpdate from '@/plugins/graphql/mutations/v2/shopify-setting-update.gql';
import AppShopifySetting from '../../../plugins/graphql/queries/app-shopify-setting.gql';
let ShopifySettings = class ShopifySettings extends Mixins(AlertMixin, DiyMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.mutationOnFlight = false;
        this.shopifySettingUuid = null;
        this.shopifySetting = {
            uuid: null,
            shopifyHostName: null,
            apiKey: null,
            apiPassword: null,
            apiVersion: null,
            accessToken: null,
            shopifyStoreDomain: null,
        };
    }
    get shopifyAppUuid() {
        return this.$route.params.appUUID || this.appUuid;
    }
    async onSubmit(form) {
        this.mutationOnFlight = true;
        const mutation = !this.shopifySettingUuid
            ? this.createShopifySetting
            : this.updateShopifySetting;
        await mutation(form)
            .then(async ({ data }) => {
            if (!data.shopifySettingAdd?.hasConnectedShopify) {
                this.$store.commit('setTodoSuccessMessage', "Your store is shaping up brilliantly! What's next?");
            }
            this.shopifySettingsAction('SUBMIT CREATE');
            this.successNotification('Shopify Setting Updated');
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
        this.mutationOnFlight = !this.mutationOnFlight;
    }
    async createShopifySetting(form) {
        const { apiKey, apiPassword, accessToken, apiVersion } = form;
        return this.$apollo.mutate({
            mutation: ShopifySettingCreate,
            variables: {
                input: {
                    appUuid: this.shopifyAppUuid,
                    shopifyHostName: form.shopifyStoreDomain,
                    apiKey,
                    accessToken,
                    apiPassword,
                    apiVersion,
                },
            },
        });
    }
    async updateShopifySetting(form) {
        const { apiKey, apiPassword, accessToken, apiVersion } = form;
        return this.$apollo.mutate({
            mutation: ShopifySettingUpdate,
            variables: {
                input: {
                    appUuid: this.shopifyAppUuid,
                    shopifyHostName: form.shopifyStoreDomain,
                    shopifySettingUuid: this.shopifySettingUuid,
                    apiKey,
                    accessToken,
                    apiPassword,
                    apiVersion,
                },
            },
        });
    }
    mounted() {
        this.shopifySettingsAction('START CREATE');
    }
};
__decorate([
    Prop({ type: String, default: null })
], ShopifySettings.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: String, default: null })
], ShopifySettings.prototype, "pageUuid", void 0);
ShopifySettings = __decorate([
    Component({
        components: {
            BaseOverlayLoader,
            ShopifySettingsForm,
        },
        apollo: {
            shopifySetting: {
                query: AppShopifySetting,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return { appUUID: this.shopifyAppUuid };
                },
                update({ app: { shopifySetting } }) {
                    this.shopifySettingUuid = shopifySetting.uuid;
                    return {
                        ...shopifySetting,
                        shopifyStoreDomain: shopifySetting.shopifyHostName,
                    };
                },
            },
        },
    })
], ShopifySettings);
export default ShopifySettings;
